module.exports = __webpack_public_path__ + "static/media/popupSH.c9c74845.png";